import { BehaviorSubject } from 'rxjs';

const bundleOffers = new BehaviorSubject({});
const subjectIsFetched = new BehaviorSubject({ fetched: false, locale: null });

const IsFetched = {
  update: (fetched, locale) => {
    subjectIsFetched.next({ fetched, locale });
  },
};

const BundeOffersStore = {
  update: (offers, locale) => {
    const offersDictionary =
      offers.length > 0
        ? offers.reduce((result, offer) => {
            result[offer._id] = offer;
            return result;
          }, {})
        : {};
    bundleOffers.next(offersDictionary);
    IsFetched.update(true, locale);
  },

  subscribe: setState => bundleOffers.subscribe(setState),
  getValue: () => bundleOffers.value,
  isFetched: locale => subjectIsFetched.value.fetched && subjectIsFetched.value.locale === locale, // compare the previous locale with the current
};

export default BundeOffersStore;
